import React from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';

import SubHeader from 'components/common/SubHeader';
import PlaceDetailService from 'components/branch/_place_detail';

import { spaceActions } from 'store/space';
import { GetBranchAPI, GetRegionsAPI } from 'api/space';

import { SubHeaderOptions } from 'constants/index';
import { AxiosResponse } from 'axios';

const PlaceDetail: NextPage = () => {
  const router = useRouter();
  if (router.isFallback) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <SubHeader options={SubHeaderOptions} selected="지점" />
      <PlaceDetailService />
    </>
  );
};

PlaceDetail.getInitialProps = async ({ store, query }) => {
  const { place } = query;

  const { data } = await GetBranchAPI(place);
  const regions: AxiosResponse = await GetRegionsAPI();

  store.dispatch(spaceActions.getBranch(data));
  store.dispatch(spaceActions.getRegions(regions.data));

  return { place };
};

export default PlaceDetail;
